module.exports = __webpack_public_path__ + "static/media/mask.4b72e4c7.svg";